import React, {useState} from "react";
import * as palette from "../Variables";
import styled from "styled-components";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const StyledPersona = styled.div`
    .img-container{
        border-radius: 300px;
        overflow: hidden;
        aspect-ratio: 1/1;
        width: 100%;
        max-width: 150px;

        img {
            width: 100%;
            object-fit: cover;
        }
    }

    .h4 span {
        color: ${palette.neutral9};
    }

    .col-md-8 {
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
    }

    .h4 {
        margin-top: 16px;
        margin-bottom: 0;
    }

    .img-demographics p {
        margin-bottom: 0;

        &.persona-type {
            margin-bottom: 8px;
            color: ${palette.neutral9};
            margin-top: -4px;
        }

        span {
            font-weight: 600;
        }
    }

    .row {
        flex-flow: column nowrap;
        row-gap: 16px;
        align-items: flex-start;
    }

    .other-info {
        display: flex;
        flex-flow: column nowrap;
        row-gap: 16px;
    }

    @media (min-width: 576px) {
        .row {
            flex-flow: row nowrap;
        }
    }

    @media (min-width: 768px) {

        .h4 {
            margin-top: 24px;
        }
    }

    .persona-category-container {
        display: none;
    }

    &.aspirations {
        .aspirations {
            display: block;
        }
    }

    &.interests {
        .interests {
            display: block;
        }
    }

    &.frustrations {
        .frustrations {
            display: block;
        }
    }

    &.attitudes {
        .attitudes {
            display: block;
        }
    }

    &.behaviors {
        .behaviors {
            display: block;
        }
    }

    &.goals {
        .goals {
            display: block;
        }
    }

    &.challenges {
        .challenges {
            display: block;
        }
    }
`;

const Persona = ({src, alt, name, personaType, demographics, interests, aspirations, frustrations, className, attitudes, behaviors, goals, challenges}) => {
    return(
        <StyledPersona className={className}>
            <Container>
                <Row>
                    <Col xs={12} sm={5} md={4} lg={3} className={"col-sm-left img-demographics"}>
                        <div className={"img-container"}>
                            <img src={src} alt={alt}/>
                        </div>
                        <h3 className={"h4"}>{name}</h3>
                        <p className={"persona-type"}>{personaType}</p>
                        {demographics}
                    </Col>
                    <Col xs={12} sm={7} md={8} lg={9} className={"col-sm-right other-info"}>
                        <div className={"persona-category-container interests"}>
                            <h4 className={"h5"}>Interests</h4>
                            {interests}
                        </div>
                        <div className={"persona-category-container aspirations"}>
                            <h4 className={"h5"}>Aspirations</h4>
                            {aspirations}
                        </div>
                        <div className={"persona-category-container attitudes"}>
                            <h4 className={"h5"}>Attitudes</h4>
                            {attitudes}
                        </div>
                        <div className={"persona-category-container behaviors"}>
                            <h4 className={"h5"}>Behaviors</h4>
                            {behaviors}
                        </div>
                        <div className={"persona-category-container goals"}>
                            <h4 className={"h5"}>Goals and motivations</h4>
                            {goals}
                        </div>
                        <div className={"persona-category-container challenges"}>
                            <h4 className={"h5"}>Challenges</h4>
                            {challenges}
                        </div>
                        <div className={"persona-category-container frustrations"}>
                            <h4 className={"h5"}>Frustrations</h4>
                            {frustrations}
                        </div>
                    </Col>
                </Row>
            </Container>
        </StyledPersona>
    )
}

export default Persona;